// src/pages/dashboard/Orders.jsx
import React from "react";
import PageShell from "./PageShell";
export default function Orders() {
  return <PageShell title="Orders" />;
}
